import {ON_DEMAND} from "../../actions";

export default (state = [], action) => {
    switch (action.type) {
        case ON_DEMAND:
            return action.payload;
        default:
            return state;
    }
};